interface IProps {
  width?: number;
  height?: number;
}

export default function Order19({ width, height }: IProps) {
  return (
    <img
      className="timeline-layout--svg--icon"
      src="https://media.synctrack.io/megamind-estimated/icon-timeline/order19.gif"
      width={width || 30}
      height={height || 30}
      alt="Order icon"
    />
  );
}
